// ** React Imports
import { createElement } from "react";

// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";

//##################################

export const VolumeBarValue = styled(({ value, ...props }) =>
	createElement("div", props)
)`
	position: absolute;
	top: -1px;
	left: 0;
	z-index: 2;
	height: 100%;

	background-color: ${({ theme: { colors } }) => colors.whiteAlways};

	${({ value }) => css`
		width: ${value};
	`}
`;

export const VolumeBarValueInput = styled("input").attrs({
	type: "range",
})`
	position: absolute;
	top: -1px;
	left: 0;
	z-index: 3;
	height: 100%;
	width: 100%;
	cursor: pointer;

	&::-webkit-slider-thumb {
		cursor: pointer;
		-webkit-appearance: none;
		height: 5px;
		width: 5px;
		background-color: ${({ theme: { colors } }) => colors.whiteTrueAlways};
	}

	&::-moz-range-thumb {
		opacity: 0;
		height: 5px;
		width: 5px;
	}
`;

export const VolumeBarContainer = styled(({ height, ...props }) =>
	createElement("div", props)
)`
	margin-left: 0.4rem;
	margin-top: 0.175rem;
	position: relative;
	height: ${({ height }) => height || "5px"};
	width: 100%;
	background-color: rgba(255, 255, 255, 0.1);
	cursor: pointer;

	&:hover {
		${VolumeBarValue} {
			background-color: #f2f2f2;
		}
		${VolumeBarValueInput} {
			&::-webkit-slider-thumb {
				background-color: #f2f2f2;
			}
		}
	}
`;

export const Dropdown = styled(Block)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 999;
	min-width: 250px;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: 0.25rem;
`;

export const SwitchingCameraButton = styled("button")`
	padding: 0.5rem 1rem;
	color: ${({ theme: { colors } }) => colors.whiteTrue};
`;
